module.exports = __webpack_public_path__ + "img/refresh-warning.f4f570c3.svg";